import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FilterChip } from '../../../../shared/interfaces/filter-chips.interface';

@Component({
  selector: 'app-course-list-header',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './course-list-header.component.html',
  styleUrl: './course-list-header.component.scss',
})
export class CourseListHeaderComponent {
  title = input<string>('');
  subtitle = input<string>('');
  coursesCount = input<number>(0);
  filterChips = input<FilterChip[]>([]);

  chipSelected = output<FilterChip>();

  onChipClick(chip: FilterChip): void {
    this.chipSelected.emit(chip);
  }
}
